import { apiFetch } from "./client";

export const cartApi = {
  getCart: () => apiFetch("/cart"),
  addToCart: (productId, quantity = 1) =>
    apiFetch("/cart/add", {
      method: "POST",
      body: JSON.stringify({ product_id: productId, quantity }),
    }),
  updateCart: (productId, quantity) =>
    apiFetch("/cart/update", {
      method: "POST",
      body: JSON.stringify({ product_id: productId, quantity }),
    }),
  removeFromCart: (productId) =>
    apiFetch("/cart/remove", {
      method: "POST",
      body: JSON.stringify({ product_id: productId }),
    }),
};
